import { render } from "./MDeleteButton.vue?vue&type=template&id=4306ace4"
import script from "./MDeleteButton.vue?vue&type=script&lang=js"
export * from "./MDeleteButton.vue?vue&type=script&lang=js"

import "./MDeleteButton.vue?vue&type=style&index=0&id=4306ace4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__